// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"56d9b57eebc669c4e083","263":"179c5d9499ee59bcc81b","791":"730ebb44f52e63b41bb4"}[chunkId] + ".js";
};